import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { api, setImgVersion } from "@/lib/api";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/cart";
import Home from "@/pages/Home";
import EventPage from "@/pages/EventPage";
import Cart from "@/pages/Cart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEvent from "@/pages/AdminEvent";
import { ProtectedRoute } from "@/components/ProtectedRoute";

function App() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    api.get("/settings/public").then((r) => setImgVersion(r.data.version)).catch(() => {}).finally(() => setReady(true));
  }, []);
  if (!ready) return null;
  return (
    <div className="app-root">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/evento/:id" element={<EventPage />} />
            <Route path="/carrinho" element={<Cart />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/eventos/:id" element={<ProtectedRoute><AdminEvent /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </div>
  );
}

export default App;
